<template>
  <div id="reservation-page-wrapper" :class="{ isFrame, isWideScreen: parentWidth > 600, isNarrowTop }">
    <div id="page-index" v-if="is_show_home == 1" v-show="indexShow" class="new-landing-wrapper">
      <div id="swiperDiv" class="new-swiper-wrap">
        <div class="swiper-container" id="indexSwiper">
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="(item, index) in banner_data" :key="index">
              <div class="landing-banner-image" :style="{ backgroundImage: 'url(' + item.image + ')' }"></div>
            </swiper-slide>
            <div class="landing-swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>

      <div class="landing-content-card">
        <div class="landing-scroll-area">
          <h1 class="landing-store-name">{{ storeName }}</h1>

          <div class="landing-address-card" @click="getMap">
            <div class="landing-address-icon">
              <a-icon type="environment" theme="filled" />
            </div>
            <div class="landing-address-text" v-html="address"></div>
            <div class="landing-address-nav">
              <a-icon type="arrow-up" class="nav-arrow" />
            </div>
          </div>

          <div class="landing-restaurant-info">
            <h3>Restaurant Info</h3>
            <div class="info-list">
              <div class="info-item" v-for="(item, index) in info" :key="index">
                <a-icon type="check" class="icon-check" v-if="item.status == 1" />
                <a-icon type="close" class="icon-close" v-else />
                <label>{{ item.name | getInfoName }}</label>
              </div>
            </div>
          </div>

          <div class="landing-notes-info" v-if="notes">
            <h3>Notes</h3>
            <div class="notes-text">{{ notes }}</div>
          </div>
        </div>

        <div class="landing-reserve-btn-wrap">
          <MyButton type="primary" block @click="go2AddReservation">
            Reserve A Table
          </MyButton>
        </div>
      </div>

      <Map :mapShow.sync="mapShow" :locationLat="locationLat" :locationLng="locationLng" :address="address"
        :storeName="storeName"></Map>
    </div>
    <loading v-show="loadingShow"></loading>

    <div id="reservation" v-show="reservationShow">
      <div class="page-container reservation-shell" id="reservation-container">
        <div class="page-content reservation-layout" id="reservation-content">
          <div class="reservation-compat-fields" aria-hidden="true">
            <input type="hidden" name="covers" id="covers" :value="currentSize" />
            <input type="hidden" name="date" id="date" :value="selectedDate" />
            <input type="hidden" name="time" id="time" :value="currentTime" />
            <input type="hidden" name="table_id" id="table_id" :value="tableString" />
            <input type="hidden" name="session_id" id="session_id" :value="selectedsessionNum" />
          </div>

          <header id="main-menu" class="logo-header reservation-header">
            <div class="store-info menu-content reservation-header-inner">
              <a-icon
                v-if="showBackButton"
                class="back-icon reservation-back-icon"
                type="left"
                @click="back"
              />
              <div class="store-name">
                <h1>{{ storeName }}</h1>
              </div>
            </div>
          </header>

          <main class="swiper-container reservation-body" id="swiper-container">
            <div class="reservation-body-inner">
              <div class="voucher-container" v-if="showVoucherContainer">
                <div class="voucher-name">{{ voucherData.name }} Applied</div>
                <template v-if="voucherData.type==0">
                  <ul class="voucher-item-list">
                    <li class="voucher-item">£{{ voucherData.face_value }} credit will be applied to your bill.</li>
                    <li class="voucher-item">Includes {{ getGiftList() }}</li>
                  </ul>
                </template> 
                <template v-if="voucherData.type==1">
                  <ul class="voucher-item-list">
                    <li class="voucher-item" v-if="voucherData.discount_type==1">£{{ voucherData.discount_amount }} off your order (Minimum spend £{{ voucherData.discount_can_value }})</li>
                    <li class="voucher-item" v-if="voucherData.discount_type==2">
                      {{ voucherData.discount_percent }}% Off Selected Item ({{ getDiscountCategory() }})
                    </li>
                  </ul>
                </template>
                <div class="voucher-available">Availability: {{ getAvailableDays() }}  {{voucherData.available_start_time}} -  {{voucherData.available_end_time}}</div>
              </div>
              <div class="reservation-content-hero">
                <div v-if="storeLogo" class="reservation-content-logo">
                  <img :src="storeLogo" :alt="storeName" />
                </div>
              </div>

              <div class="swiper-wrapper reservation-step-stack">
                <ReservationStep0
                  v-show="step === 0"
                  :currentSize="currentSize"
                  :max-covers="storeCovers"
                  @changeSize="changeSize"
                />
                <ReservationStep1 v-show="step === 1" />
                <ReservationStep2 v-show="step === 2" :sessionArr="sessionArr"
                  :selected-session-num="selectedsessionNum" :time-active="timeActive" :timeArr="timeArr"
                  :currentTime="currentTime" @sessionSelected="handleStep2SessionSelected"
                  @timeSelected="handleStep2TimeSelected" />
                <ReservationStep3 ref="step3Component" v-show="step === 3" :infoForm="infoForm" :country="country" :areaCode="areaCode"
                  :allergy_show="allergy_show" @getAreaCode="getAreaCode" @allergySelect="allergySelect" />
                <ReservationStep4 v-show="step === 4" :infoForm="infoForm" :depositPrice="depositPrice"
                  :currentSize="currentSize" :currentDate="currentDate" :week="week" :currentTime="currentTime"
                  :storeName="storeName" :accepted="!read" :sendEmail="send_email" :sendSms="send_sms" @readNot="readNot"
                  @termsAndConditions="termsAndConditions" @setSendEmail="setSendEmail" @setSendSms="setSendSms" />
                <ReservationStep5 v-show="step === 5" :infoForm="infoForm" :depositeArr="depositeArr" :deposite="deposite"
                  :currentSize="currentSize" @depositeTabs="depositeTabs" @next="next" />
                <ReservationStep6 v-show="step === 6" :storeName="storeName" :infoForm="infoForm"
                  :currentDate="currentDate" :week="week" :currentTime="currentTime" :currentSize="currentSize"
                  :depositPrice="depositPrice" :ics_url="ics_url" @makeAnotherBook="makeAnotherBook" />
              </div>
            </div>
          </main>

          <footer class="reservation-footer">
            <div v-if="showPlanningTip" class="planning-tip-wrapper">
              <div class="party-size-tip" @click="largerBookBtn">
                <div class="tip-text">
                  Planning a big party? Tap here to request more space
                </div>
                <img class="tip-icon" src="/static/images/planning_icon.svg" />
              </div>
            </div>
            <MyButton
              v-if="showFooterAction"
              :id="footerActionId"
              type="primary"
              block
              class="nextBtn nextBtn-success reservation-footer-btn"
              :disabled="footerActionDisabled"
              @click="handleFooterAction"
            >
              {{ footerActionLabel }}
            </MyButton>
          </footer>
        </div>
      </div>

      <div class="modal fade modal-default" role="basic" id="modal-ajax" aria-labelledby="modalDefaultLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content" id="modalAjax">
            <div class="modal-header bg-info" style="padding: 5px 10px">
              <h5 class="modal-title" id="modalDefaultLabel" v-show="step === 3">
                Allergen:
              </h5>
              <h5 class="modal-title" id="modalDefaultLabel" v-show="step === 4">
                Restaurant Terms And Conditions
              </h5>
              <button class="close" type="button" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body" id="allergyModalBody" v-show="step === 3">
              <modalAllergy></modalAllergy>
            </div>
            <div class="modal-body" id="modalAjaxBody" v-show="step === 4">
              <modalAjax></modalAjax>
            </div>
            <div class="modal-footer">
              <MyButton type="default" @click="$('#modal-ajax').modal('hide')">
                Close
              </MyButton>
              <MyButton id="confirmAllergyBtn" @click="modalAllergyConfirm" v-show="step === 3" type="primary">
                Confirm
              </MyButton>
              <MyButton id="acceptBtn" v-show="step === 4" type="primary" @click="acceptTheTerm">
                Accept
              </MyButton>
            </div>
          </div>
        </div>
      </div>

      <div id="alertCol" class="" v-if="alertCol">
        <div class="alertContent">
          <p v-html="errorWords"></p>
        </div>
      </div>

      <BookingEnquiryModal ref="myModal"
        :date-format="dateFormat"
        :covers-select-arr="coversSelectArr"
        :time-select-arr="timeSelectArr"
        :country="country"
        :area-code="areaCode"
        :confirm-loading="confirmLoading"
        @error="handleBookingEnquiryError"
        @submit="handleModalSubmit"
        @getAreaCode="getAreaCode"
      />

      <BaseModal
        :visible="confirmedModalVisible"
        :closable="false"
        :showCancel="false"
        wrapClassName="reservation-feedback-modal reservation-confirm-modal"
        okText="OK"
        @ok="hideConfirmedModal"
      >
        <div class="reservation-modal-card">
          <div class="reservation-modal-hero reservation-modal-hero--email">
            <div class="reservation-modal-badge">
              <img src="@/assets/images/email.png" alt="" />
            </div>
            <div class="reservation-modal-copy">
              <h3>Booking Confirmed</h3>
              <p class="reservation-modal-lead">
                Your booking has been confirmed and a confirmation email is on its way.
              </p>
            </div>
          </div>
          <div class="reservation-modal-note">
            <span class="reservation-modal-note-label">Reminder</span>
            <p>
              If you have not received your booking confirmation email, please check your
              <span class="reservation-modal-accent">Spam Folder</span>.
            </p>
          </div>
        </div>
      </BaseModal>

      <BaseModal
        :visible="largerBookSuccessModalVisible"
        :closable="false"
        :showCancel="false"
        wrapClassName="reservation-feedback-modal reservation-enquiry-modal"
        okText="OK"
        @ok="hideSuccessModal"
      >
        <div class="reservation-modal-card">
          <div class="reservation-modal-hero reservation-modal-hero--success">
            <div class="reservation-modal-badge reservation-modal-badge--success">
              <a-icon type="check" />
            </div>
            <div class="reservation-modal-copy">
              <h3>Booking Request Sent</h3>
              <p class="reservation-modal-lead">
                Please check your emails for updates on your booking enquiry.
              </p>
            </div>
          </div>
          <div class="reservation-modal-note reservation-modal-note--soft">
            <p>We will be in touch as soon as possible once the team has reviewed your request.</p>
          </div>
        </div>
      </BaseModal>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment";
//import { Card, createToken } from 'vue-stripe-elements';
// import jquery from '../../static/plugins/jquery/dist/jquery';
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import "../../static/plugins/fullcalendar/dist/fullcalendar";
import "../../static/plugins/fullcalendar/dist/localeAll";
import "../../static/plugins/fullcalendar/dist/gcal";
import Loading from "../components/loading.vue";
import modalAjax from "../components/modalAjax.vue";
import modalAllergy from "../components/modalAllergy.vue";
import Map from "@/components/Map";

import ReservationStep0 from "@/components/ReservationStep0.vue";
import ReservationStep1 from "@/components/ReservationStep1.vue";
import ReservationStep2 from "@/components/ReservationStep2.vue";
import ReservationStep3 from "@/components/ReservationStep3.vue";
import ReservationStep4 from "@/components/ReservationStep4.vue";
import ReservationStep5 from "@/components/ReservationStep5.vue";
import ReservationStep6 from "@/components/ReservationStep6.vue";
import MyButton from "@/components/MyButton.vue";
import BaseModal from "@/components/BaseModal.vue";
import BookingEnquiryModal from "@/components/BookingEnquiryModal.vue";

import { configTheme } from "@/utils/theme";

import axios from "axios";

export default {
  name: "Reservation",
  components: {
    Loading,
    modalAjax,
    modalAllergy,
    swiper,
    swiperSlide,
    Map,
    ReservationStep0,
    ReservationStep1,
    ReservationStep2,
    ReservationStep3,
    ReservationStep4,
    ReservationStep5,
    ReservationStep6,
    MyButton,
    BaseModal,
    BookingEnquiryModal
  },
  inject: ["reload"],
  data() {
    return {
      storeLogo: "",
      storeName: "",
      storeCovers: 10,
      currentSize: "",
      sizeActive: "",
      nextShow: false,
      step: 0,
      currentDate: "",
      week: "",
      alertCol: false,
      currentTime: "",
      sessionArr: [],
      timeActive: 0,
      timeSelectActive: ["", "", ""],
      infoForm: {
        firstName: "",
        surname: "",
        areaCode: "+44",
        phone: "",
        email: "",
        remark: "",
        allergy: "",
      },
      read: true,
      depositeArr: ["Card", "Cash", "Poynt", "Paymentsense"],
      deposite: "",
      disabledDay: [],
      selectedDate: "",
      timeArr: [],
      tableString: "",
      selectedsessionNum: 0,
      store_id: 0,
      loadingShow: true,
      send_email: 0,
      send_sms: 0,
      errorWords: "",
      depositPrice: "40.00",

      dateFormat: "DD MMM YYYY",
      timeFormat: "HH:mm",
      duration: 0,
      is_holding_time: 0,
      allergy_show: 0,
      areaCode: "+44",
      country: "UK",
      reservation_id: 0,
      ics_url: "javascript:void(0)",
      confirmLoading: false,
      is_show_home: 0,
      indexShow: false,
      reservationShow: true,
      banner_data: [
        {
          id: 933,
          image:
            "https://sparkepos.s3.eu-west-2.amazonaws.com/ccdb58d7b920f18fd9cf3b03aa63fab5.png",
          status: 1,
        },
        {
          id: 932,
          image:
            "https://sparkepos.s3.eu-west-2.amazonaws.com/a6dc6c5956acbb1db56f3f9855ad598f.png",
          status: 1,
        },
      ],
      info: [
        {
          id: 1,
          name: "valet_parking",
          status: 1,
        },
        {
          id: 2,
          name: "smoking_allowed",
          status: 1,
        },
        {
          id: 3,
          name: "serves_alcohol",
          status: 0,
        },
        {
          id: 4,
          name: "outdoor_seating",
          status: 1,
        },
        {
          id: 5,
          name: "smart_casual",
          status: 0,
        },
      ],
      expensive_rate: 2,
      notes: "dafadsf",
      swiperOption: {
        direction: "horizontal",
        loop: true,
        speed: 300,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: ".landing-swiper-pagination",
          type: "bullets",
          clickable: true, //允许分页点击跳转
        },
      },
      address: "",
      locationLat: "",
      locationLng: "",
      mapShow: false,
      confirmedModalVisible: false,
      largerBookSuccessModalVisible: false,
      customTheme: {},
      parentWidth: 600,
      syncingStepFromRoute: false,
      restoringDraft: false,
      voucherData: {}

      // currentDate: "24 May 2024",
      // step: 4,
      // currentSize: 2,
      // currentTime: "04:30",
      // infoForm: {
      //   email: "df@setInterval.com",
      //   firstName: "Victor",
      //   surname: "JIANG",
      //   phone: "15455668834",
      // },
      // week: 23,
    };
  },
  watch: {
    "$route.query.step"(queryStep) {
      const nextStep = this.getStepFromRouteQuery(queryStep);

      if (this.step !== nextStep) {
        this.syncingStepFromRoute = true;
        this.step = nextStep;
        this.$nextTick(() => {
          this.syncingStepFromRoute = false;
        });
      }
    },
    reservationDraftPayload: {
      deep: true,
      handler() {
        this.persistReservationDraft();
      },
    },
    step(newVal, oldVal) {
      if (oldVal === 3 && newVal === 4) {
        this.blurActiveField();
      }

      // Sync URL - step matches directly
      const currentRouteStep = this.getStepFromRouteQuery(this.$route.query.step);
      if (
        !this.syncingStepFromRoute &&
        currentRouteStep !== newVal
      ) {
        this.syncReservationStepToRoute(newVal);
      }

      // Manage Step Button Visibility 
      if (newVal < 6 && newVal !== 5 && newVal !== 4 && newVal !== 3) {

      }
      if (newVal === 3) {

      }

      // step 变化后，根据当前页面重新挂载需要的旧 jQuery 组件/数据
      if (oldVal !== undefined) {
        this.refreshStepData(newVal, oldVal);
      }
      this.persistReservationDraft();
      this.$nextTick(() => {
        this.syncDraftUiState();
        if (newVal === 1 || (oldVal === 3 && newVal === 4)) {
          this.refreshViewportLayout();
        }
      });
    }
  },
  computed: {
    timeSelectArr() {
      let h = 0;
      let interval = 15;
      let time = 0;
      let curArr = [];
      for (let i = 0; i <= 95; i++) {
        if (time == 60) {
          time = 0;
          h = h + 1;
        }
        let s = (h > 9 ? h : "0" + h) + ":" + (time > 0 ? time : "00");
        time = time + interval;
        curArr.push(s);
      }
      return curArr;
    },
    coversSelectArr() {
      var openData = [];
      for (var i = 1; i < 101; i++) {
        openData.push(i);
      }
      JSON.stringify(openData);
      return openData;
    },
    isFrame() {
      return this.$route.query.is_frame == 1;
    },
    isNarrowTop() {
      return false;
      return this.step >= 3;
    },
    showBackButton() {
      return this.step !== 0;
    },
    showPlanningTip() {
      return this.step === 0 || this.step === 1 || this.step === 2;
    },
    showFooterAction() {
      return this.step !== 6;
    },
    footerActionId() {
      if (this.step === 4) {
        return "confirmSubmit";
      }
      if (this.step === 5) {
        return "payNowSubmit";
      }
      return "nextToSelectSubmit";
    },
    footerActionLabel() {
      if (this.step === 4) {
        return "COMPLETE";
      }
      if (this.step === 5) {
        return "Pay Now";
      }
      return "NEXT";
    },
    footerActionDisabled() {
      if (this.step === 0) {
        return !this.sizeActive;
      }
      if (this.step === 1) {
        return !this.selectedDate;
      }
      if (this.step === 2) {
        return !this.currentTime;
      }
      if (this.step === 3) {
        const firstName = (this.infoForm.firstName || "").trim();
        const surname = (this.infoForm.surname || "").trim();
        const phone = (this.infoForm.phone || "").trim();
        const email = (this.infoForm.email || "").trim();
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        return (
          firstName.length < 2 ||
          surname.length < 2 ||
          phone.length < 10 ||
          !emailPattern.test(email)
        );
      }
      if (this.step === 4) {
        return this.read;
      }
      if (this.step === 5) {
        return (
          !this.deposite ||
          this.deposite === "Poynt" ||
          this.deposite === "Paymentsense"
        );
      }
      return false;
    },
    reservationDraftPayload() {
      return {
        step: this.step,
        currentSize: this.currentSize,
        sizeActive: this.sizeActive,
        currentDate: this.currentDate,
        week: this.week,
        currentTime: this.currentTime,
        selectedDate: this.selectedDate,
        timeActive: this.timeActive,
        timeSelectActive: Array.isArray(this.timeSelectActive)
          ? [...this.timeSelectActive]
          : ["", "", ""],
        tableString: this.tableString,
        selectedsessionNum: this.selectedsessionNum,
        duration: this.duration,
        is_holding_time: this.is_holding_time,
        depositPrice: this.depositPrice,
        infoForm: {
          ...this.infoForm,
          areaCode: this.areaCode,
        },
        read: this.read,
        send_email: this.send_email,
        send_sms: this.send_sms,
        areaCode: this.areaCode,
        country: this.country,
        deposite: this.deposite,
        nextShow: this.nextShow,
      };
    },
    voucherUuid() {
      return this.$route.query.voucher;
    },
    showVoucherContainer() {
      return (
        !!this.voucherUuid &&
        this.voucherData &&
        !Array.isArray(this.voucherData) &&
        Object.keys(this.voucherData).length > 0
      );
    }
  },
  created() {
    this.loadingShow = true;
    var store_name = this.$route.params.store_name;
    const restoredDraft = this.restoreReservationDraft();

    if (!restoredDraft) {
      this.step = this.getStepFromRouteQuery(this.$route.query.step);
    }

    if (store_name != 0) {
      this.getStoreData(store_name);
    }

    if(this.voucherUuid){
      this.getVoucherData(this.voucherUuid);
    }
  },
  filters: {
    getInfoName(value) {
      var name,
        arr = new Array();
      arr = value.split("_");
      name = arr[0] + " " + arr[1];
      if (name == "smoking allowed") {
        return "smoking area";
      }
      if (name == "valet parking") {
        return "parking";
      }
      if (name == "smart casual") {
        return "dog friendly";
      }
      return name;
    }
  },
  methods: {
    hasExplicitRouteStep() {
      const routeStep = this.$route.query.step;
      const parsedStep = parseInt(routeStep, 10);
      return !isNaN(parsedStep) && parsedStep >= 1 && parsedStep <= 7;
    },
    syncReservationStepToRoute(step = this.step, options = {}) {
      const { replace = false } = options;
      const nextQuery = {
        ...this.$route.query,
        step: this.normalizeDraftStep(step) + 1,
      };
      const navigation = {
        path: this.$route.path,
        query: nextQuery,
      };
      const routerAction = replace ? this.$router.replace : this.$router.push;

      routerAction.call(this.$router, navigation).catch(() => { });
    },
    blurActiveField() {
      const activeElement = document.activeElement;
      if (
        activeElement &&
        typeof activeElement.blur === "function" &&
        /^(INPUT|TEXTAREA|SELECT)$/.test(activeElement.tagName)
      ) {
        activeElement.blur();
      }
    },
    refreshViewportLayout() {
      if (typeof window === "undefined") {
        return;
      }

      window.dispatchEvent(new Event("resize"));
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 60);
    },
    blurStep3Fields() {
      const step3El =
        this.$refs.step3Component && this.$refs.step3Component.$el;
      if (!step3El || !step3El.querySelectorAll) {
        return;
      }

      const fields = step3El.querySelectorAll("input, textarea, select");
      fields.forEach((field) => {
        if (field && typeof field.blur === "function") {
          field.blur();
        }
      });
    },
    scrollReservationBodyToTop() {
      const reservationBody = document.getElementById("swiper-container");
      if (reservationBody) {
        reservationBody.scrollTop = 0;
      }

      if (typeof window !== "undefined") {
        window.scrollTo(0, 0);
      }
    },
    prepareStep4Transition(callback) {
      this.blurStep3Fields();
      this.blurActiveField();
      this.refreshViewportLayout();

      setTimeout(() => {
        this.refreshViewportLayout();
        if (typeof callback === "function") {
          callback();
        }
      }, 120);
    },
    getStepFromRouteQuery(routeStep) {
      if (routeStep === undefined || routeStep === null || routeStep === "") {
        return 0;
      }

      const parsedStep = parseInt(routeStep, 10);
      if (!isNaN(parsedStep) && parsedStep >= 1 && parsedStep <= 7) {
        return parsedStep - 1;
      }

      return 0;
    },
    refreshStepData(step, prevStep) {
      if (!this.store_id || !this.sizeActive) {
        return;
      }

      if (step === 1) {
        this.$nextTick(() => {
          this.loadingShow = true;
          this.getWidgetReserveDate(this.store_id, this.sizeActive);
        });
        return;
      }

      if (step === 2) {
        const selectedDate =
          $("#date").val() ||
          this.getSelectedDateValue();

        if (!selectedDate) {
          return;
        }

        this.selectedDate = selectedDate;
        this.$nextTick(() => {
          this.loadingShow = true;
          this.getReserveTime(
            this.store_id,
            this.sizeActive,
            selectedDate,
            prevStep > step ? (this.selectedsessionNum || 0) : 0
          );
        });
      }
    },
    getReservationDraftKey() {
      return `reservation_draft:${this.$route.params.store_name || "default"}`;
    },
    getSelectedDateValue() {
      if (this.selectedDate) {
        return this.selectedDate;
      }

      if (!this.currentDate) {
        return "";
      }

      const parsedDate = moment(this.currentDate, "DD MMM YYYY", true);
      return parsedDate.isValid() ? parsedDate.format("YYYY-MM-DD") : "";
    },
    formatStoreAddress(storeData) {
      if (!storeData || typeof storeData !== "object") {
        return "";
      }

      const addressLine = (storeData.address || "").trim();
      const city = (storeData.city || "").trim();
      const postcode = (storeData.postal_code || "").trim();

      return [addressLine, city, postcode].filter(Boolean).join(", ");
    },
    normalizeDraftStep(step) {
      let nextStep = parseInt(step, 10);
      if (isNaN(nextStep) || nextStep < 0) {
        nextStep = 0;
      }
      return Math.min(nextStep, 6);
    },
    persistReservationDraft() {
      if (this.restoringDraft) {
        return;
      }

      if (this.step === 6) {
        this.clearReservationDraft();
        return;
      }

      localStorage.setItem(
        this.getReservationDraftKey(),
        JSON.stringify({
          ...this.reservationDraftPayload,
          updatedAt: Date.now(),
        })
      );
    },
    restoreReservationDraft() {
      const draftRaw = localStorage.getItem(this.getReservationDraftKey());
      if (!draftRaw) {
        return false;
      }

      try {
        const draft = JSON.parse(draftRaw);
        if (
          draft.updatedAt &&
          Date.now() - draft.updatedAt > 24 * 60 * 60 * 1000
        ) {
          this.clearReservationDraft();
          return false;
        }
        const parsedDraftDate =
          draft.currentDate &&
            moment(draft.currentDate, "DD MMM YYYY", true).isValid()
            ? moment(draft.currentDate, "DD MMM YYYY", true).format(
              "YYYY-MM-DD"
            )
            : "";
        this.restoringDraft = true;

        this.currentSize = draft.currentSize || "";
        this.sizeActive = draft.sizeActive || this.currentSize || "";
        this.currentDate = draft.currentDate || "";
        this.week = draft.week || "";
        this.currentTime = draft.currentTime || "";
        this.selectedDate = draft.selectedDate || parsedDraftDate;
        this.timeActive = isNaN(parseInt(draft.timeActive, 10))
          ? 0
          : parseInt(draft.timeActive, 10);
        this.timeSelectActive = Array.isArray(draft.timeSelectActive)
          ? [...draft.timeSelectActive]
          : ["", "", ""];
        this.tableString = draft.tableString || "";
        this.selectedsessionNum = draft.selectedsessionNum || 0;
        this.duration = draft.duration || 0;
        this.is_holding_time = draft.is_holding_time || 0;
        this.depositPrice = draft.depositPrice || this.depositPrice;
        this.infoForm = {
          ...this.infoForm,
          ...(draft.infoForm || {}),
        };
        this.read = typeof draft.read === "boolean" ? draft.read : this.read;
        this.send_email =
          typeof draft.send_email === "number"
            ? draft.send_email
            : this.send_email;
        this.send_sms =
          typeof draft.send_sms === "number" ? draft.send_sms : this.send_sms;
        this.areaCode = draft.areaCode || this.infoForm.areaCode || this.areaCode;
        this.infoForm.areaCode = this.areaCode;
        this.country = draft.country || this.country;
        this.deposite = draft.deposite || "";
        this.nextShow =
          typeof draft.nextShow === "boolean"
            ? draft.nextShow
            : !!this.sizeActive;

        const hasExplicitRouteStep =
          this.$route.query.step !== undefined &&
          this.$route.query.step !== null &&
          this.$route.query.step !== "";
        const stepFromRoute = hasExplicitRouteStep
          ? this.getStepFromRouteQuery(this.$route.query.step)
          : 0;
        this.step = this.normalizeDraftStep(stepFromRoute);

        return true;
      } catch (error) {
        localStorage.removeItem(this.getReservationDraftKey());
        return false;
      } finally {
        this.restoringDraft = false;
      }
    },
    clearReservationDraft() {
      localStorage.removeItem(this.getReservationDraftKey());
    },
    syncDraftUiState() {
      const selectedDate = this.getSelectedDateValue();
      if (selectedDate) {
        $("#date").val(selectedDate);
      }

      if (
        (this.step === 0 && this.sizeActive) ||
        (this.step === 1 && selectedDate) ||
        (this.step >= 2 && this.currentTime)
      ) {

      }
    },
    rehydrateDraftState() {
      const hasRouteStep = this.hasExplicitRouteStep();

      if (
        hasRouteStep &&
        (
          this.step > 0 ||
          this.sizeActive ||
          this.currentDate ||
          this.currentTime ||
          this.infoForm.firstName
        )
      ) {
        this.indexShow = false;
        this.reservationShow = true;
      }

      if (!this.sizeActive || !this.store_id) {
        this.syncDraftUiState();
        return;
      }

      const selectedDate = this.getSelectedDateValue();
      this.syncDraftUiState();

      this.loadingShow = true;
      this.getWidgetReserveDate(this.store_id, this.sizeActive);

      if (this.step >= 2 && selectedDate) {
        this.loadingShow = true;
        this.getReserveTime(
          this.store_id,
          this.sizeActive,
          selectedDate,
          this.selectedsessionNum || 0,
          {
            fallbackToPrev: this.step < 3,
          }
        );
      }
    },
    clearTimeSelection() {
      this.currentTime = "";
      this.tableString = "";
      this.timeSelectActive = ["", "", ""];
      this.selectedsessionNum = 0;
      this.duration = 0;
      this.timeActive = 0;
      try {
        $("#selectTime-mod").find(".timeLabel").removeClass("active");
      } catch (e) { }
    },
    clearDateAndTimeSelection() {
      this.week = "";
      this.currentDate = "";
      this.selectedDate = "";
      $("#date").val("");
      try {
        $("#dateSelect-calendar").find("a").removeClass("selected-date");
      } catch (e) { }
      this.clearTimeSelection();
    },
    getStoreData(store_name) {
      axios
        .get(process.env.API_URL + "htmlReserve/getStoreData", {
          params: { store_name: store_name },
        })
        .then((res) => {
          localStorage.setItem("store_data", JSON.stringify(res.data.data));
          if (res.data.code == -1) {
            this.errorWords = res.data.message;
            setTimeout(this.alertTips, 100);

          } else {
            try {
              if (res.data.data.style_status == 1) {
                this.customTheme = res.data.data.style_content;
                const { brandColor, fontColor } = this.customTheme;
                configTheme(brandColor, fontColor);
              } else {
                configTheme("#f08a24", "#000000");
              }
            } catch (error) {}
            this.store_id = res.data.data.store_id;
            localStorage.setItem("store_id", res.data.data.store_id);
            this.storeName = res.data.data.store_name;
            this.storeLogo = res.data.data.logo;
            this.storeCovers = parseInt(res.data.data.covers, 10) > 0
              ? parseInt(res.data.data.covers, 10)
              : 10;
            this.is_show_home = res.data.data.is_show_home;
            const hasRouteStep = this.hasExplicitRouteStep();
            if (res.data.data.is_show_home == 1 && !hasRouteStep) {
              this.indexShow = true;
              this.reservationShow = false;
            } else {
              this.indexShow = false;
              this.reservationShow = true;
              if (!hasRouteStep) {
                this.syncReservationStepToRoute(0, { replace: true });
              }
            }
            this.banner_data = res.data.data.banner_data;
            this.expensive_rate = res.data.data.expensive_rate;
            this.info = res.data.data.info;
            this.notes = res.data.data.notes;
            this.address = this.formatStoreAddress(res.data.data);

            this.locationLat = res.data.data.lat;
            this.locationLng = res.data.data.lng;
            this.loadingShow = false;
            this.$nextTick(() => {
              this.rehydrateDraftState();
            });
          }
        });
    },
    getVoucherData(voucherUuid) {
      axios
        .get(process.env.API_URL + "new_reserve/voucher_info", {
          params: { voucher: voucherUuid },
        })
        .then((res) => {
          if (res.data.code == 200) {
            const voucherData = res.data.data;
            this.voucherData =
              voucherData && !Array.isArray(voucherData) ? voucherData : {};
          }
        });
    },

    getGiftList() {
      let giftListStr = ''
      if(this.voucherData && this.voucherData.discount_products) {
        const arr = this.voucherData.discount_products.map(item => {
          let sku_name = item.sku_name;
          if(sku_name == '-') {
            sku_name = ''
          }
          return `${item.num} free ${item.spu_name} ${sku_name}`
        })
        giftListStr = arr.join(', ');
      }
      return giftListStr;
    },

    getDiscountCategory() {
      let discountCategoryStr = ''
      const arr = this.voucherData.discount_category || [];
      // 获取arr的前3项
      if(arr.length <= 3) {
        discountCategoryStr = arr.join(', ');
      } else {
        discountCategoryStr = arr.slice(0, 3).join(', ') + '...';
      }
      return discountCategoryStr;
    },

    getAvailableDays() {
      let availableDayStr = ''
      
      if(this.voucherData && this.voucherData.available_time_week) {
        
        // Fri: "0",Mon: "1",Sat: "0",Sun: "0",Thu: "0",Tue: "1",Wed: "1",如果value为0则不显示，然后按照周一到周日排序，然后组合成字符串，用逗号隔开
        const weekArr = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        weekArr.forEach(item=>{
          if(this.voucherData.available_time_week[item] == '1') {
            availableDayStr += item + ', ';
          }
        })
      }
      return availableDayStr;
    },
    getEnabledSessions(sessionArr) {
      if (!Array.isArray(sessionArr)) {
        return [];
      }

      return sessionArr.filter(
        (item) => item && typeof item === "object" && Number(item.booking_switch) !== 0
      );
    },

    getReserveTime(store_id, customerNum, date, sessionNum, options = {}) {
      const shouldFallbackToPrev = options.fallbackToPrev !== false;
      axios
        .get(process.env.API_URL + "htmlReserve/getReserveTime", {
          params: {
            store_id: store_id,
            customerNum: customerNum,
            date: date,
            sessionNum: sessionNum,
            // sessionNum: 130,
          },
        })
        .then((res) => {
          // console.log(res);
          if (res.data.code == 200) {
            const reserveData = res.data.data || {};
            this.sessionArr = this.getEnabledSessions(reserveData.sessioon_arr);
            this.timeArr = Array.isArray(reserveData.time_arr)
              ? reserveData.time_arr
              : [];

            if (!this.sessionArr.length) {
              this.timeArr = [];
              this.timeActive = 0;
              this.selectedsessionNum = 0;
              this.currentTime = "";
              this.tableString = "";
              this.is_holding_time = 0;
              this.duration = 0;
              this.depositPrice = "0.00";
              localStorage.setItem("depositPrice", "0.00");
              this.allergy_show = 0;
              this.loadingShow = false;
              this.syncDraftUiState();
              return;
            }

            let activeIndex = sessionNum
              ? this.sessionArr.findIndex(
                (item) => String(item.id) === String(sessionNum)
              )
              : 0;

            if (activeIndex < 0 && !sessionNum) {
              activeIndex = this.timeActive;
            }

            if (activeIndex < 0 || activeIndex >= this.sessionArr.length) {
              activeIndex = 0;
            }

            const selectedSession = this.sessionArr[activeIndex];
            if (
              sessionNum &&
              String(selectedSession.id) !== String(sessionNum)
            ) {
              this.timeActive = activeIndex;
              this.selectedsessionNum = selectedSession.id;
              this.currentTime = "";
              this.tableString = "";
              this.timeArr = [];
              this.getReserveTime(
                store_id,
                customerNum,
                date,
                selectedSession.id,
                options
              );
              return;
            }

            this.timeActive = activeIndex;
            this.selectedsessionNum = selectedSession.id;
            this.is_holding_time = selectedSession.is_holding_time;

            var duration_arr = selectedSession.durationas_set || "";
            var duration_data = String(duration_arr).split(",");
            var durationIndex = this.currentSize > 7 ? 7 : this.currentSize - 1;
            this.duration =
              duration_data[durationIndex] ||
              duration_data[duration_data.length - 1] ||
              0;
            // console.log(this.duration)

            this.loadingShow = false;
            var signleDeposit = Number(selectedSession.deposit) || 0;
            var total = (signleDeposit * (Number(this.currentSize) || 0)) / 100;
            this.depositPrice = total.toFixed(2);
            localStorage.setItem("depositPrice", total.toFixed(2));
            this.allergy_show = selectedSession.is_open_allergen;
            this.syncDraftUiState();
          } else {
            this.errorWords = res.data.message;
            setTimeout(this.alertTips, 100);
            this.loadingShow = false;
            if (shouldFallbackToPrev) {
              this.clearTimeSelection();
              this.prev();

            }

            // location.reload();
          }
        });
    },

    getWidgetReserveDate(store_id, selectedCustNumber) {
      axios
        .get(process.env.API_URL + "htmlReserve/getWidgetReserveDate", {
          params: {
            store_id: store_id,
            custNum: selectedCustNumber || this.currentSize,
          },
        })
        .then((res) => {
          //  console.log(res.data.data.disabled);
          this.disabledDay = res.data.data.disabled;
          $("#dateSelect-calendar").fullCalendar("destroy");
          this.selectDate(this.disabledDay);
          this.loadingShow = false;
          this.syncDraftUiState();
          this.$nextTick(() => {
            this.refreshViewportLayout();
          });
        });
    },
    createWebPend(
      first_name,
      last_name,
      store_id,
      currentDate,
      currentTime,
      infoForm,
      currentSize,
      send_email,
      areacode,
      phone
    ) {
      axios
        .post(process.env.API_URL + "pend/create", {
          store_id: store_id,
          date: currentDate,
          start_time: currentTime,
          notes: infoForm,
          covers: currentSize,
          email: send_email,
          areacode_p: areacode,
          first_name: first_name,
          last_name: last_name,
          phone: phone,
        })
        .then((res) => {
          // if (res.data.code==200) {
          //     this.confirmLoading = false
          //     this.cancelLargerBookClick()
          // }
        });
    },

    createWebReserve(
      store_id,
      currentDate,
      currentTime,
      infoForm,
      tableString,
      currentSize,
      selectedsessionNum,
      send_email,
      send_sms
    ) {
      const body = {
        params: {
          store_id: store_id,
          currentDate: currentDate,
          currentTime: currentTime,
          infoForm: infoForm,
          tableString: tableString,
          currentSize: currentSize,
          selectedsessionNum: selectedsessionNum,
          send_email: send_email,
          send_sms: send_sms,
        }
      }
      if (this.voucherUuid) {
        body.voucher = this.voucherUuid
      }
      axios
        .post(process.env.API_URL + "htmlReserve/createWebReserve", body)
        .then((res) => {
          if (res.data.code == 200) {
            this.reservation_id = res.data.data.id;
            localStorage.setItem("reservation_id", res.data.data.id);
            localStorage.setItem(
              "opayo_set_status",
              res.data.data.opayo_set_status
            );
            localStorage.setItem(
              "viva_set_status",
              res.data.data.viva_set_status
            );
            this.ics_url = res.data.data.ics_url;
            this.loadingShow = false;
            if (res.data.data.amount > 0) {
              localStorage.setItem("priceTotal", res.data.data.amount);
              this.$router.push({
                path: "/selectcard",
              });
            } else {
              this.clearReservationDraft();
              this.step = 6;
              this.confirmedModalVisible = true;
              this.loadingShow = false;
            }
          } else {
            // this.step = 5;
            this.errorWords = res.data.message;
            setTimeout(this.alertTips, 100);
            this.loadingShow = false;
          }
        });
    },

    setSendEmail() {
      if (this.send_email == 0) {
        this.send_email = 1;
      } else {
        this.send_email = 0;
      }
    },
    setSendSms() {
      if (this.send_sms == 0) {
        this.send_sms = 1;
      } else {
        this.send_sms = 0;
      }
    },

    //选择party size
    changeSize(val, index) {
      if (String(this.sizeActive) !== String(val)) {
        this.clearDateAndTimeSelection();
      }
      this.currentSize = val;
      this.sizeActive = val;
      if (!this.nextShow) this.nextShow = true;

      this.persistReservationDraft();
    },

    // 上一步
    prev() {
      if (this.step > 0) {
        this.step--;
      }
    },
    // 下一步
    next() {
      if (this.step < 6 && this.step !== 4) {
        if (this.step === 3) {
          this.prepareStep4Transition(() => {
            if (this.$refs.step3Component && this.$refs.step3Component.validateForm) {
              this.$refs.step3Component.validateForm((valid) => {
                if (valid) {
                  this.infoForm.areaCode = this.areaCode;
                  this.step++;
                  this.persistReservationDraft();
                  this.$nextTick(() => {
                    this.scrollReservationBodyToTop();
                    this.refreshViewportLayout();
                  });
                }
              });
            }
          });
        } else {
          this.step++;
          this.persistReservationDraft();
        }
      }
    },
    handleFooterAction() {
      if (this.footerActionDisabled) {
        return;
      }
      if (this.step === 4) {
        this.complete(this.step);
        return;
      }
      this.next();
    },
    alertTips() {
      this.alertCol = true;
      setTimeout(() => {
        this.alertCol = false;
      }, 1000);
    },
    handleStep2TimeSelected(payload) {
      if (payload && typeof payload === "object") {
        this.currentTime = payload.time || "";
        this.tableString = payload.table_id || "";
      } else {
        this.currentTime = payload || "";
        this.tableString = "";
      }

      this.persistReservationDraft();
    },
    handleStep2SessionSelected(payload) {
      if (!payload || !payload.sessionNum) {
        return;
      }

      const selectedDate = $("#date").val() || this.getSelectedDateValue();
      this.timeActive = payload.index;
      this.selectedsessionNum = payload.sessionNum;
      this.currentTime = "";
      this.tableString = "";
      this.timeSelectActive = ["", "", ""];
      this.timeArr = [];

      if (!selectedDate || !this.store_id || !this.sizeActive) {
        this.persistReservationDraft();
        return;
      }

      this.selectedDate = selectedDate;
      this.loadingShow = true;
      this.getReserveTime(
        this.store_id,
        this.sizeActive,
        selectedDate,
        payload.sessionNum,
        {
          fallbackToPrev: false,
        }
      );
    },
    largerBookBtn() {
      this.currentSize = "";

      this.$refs.myModal.open();
      this.areaCode = "+44";
      this.country = "UK";
    },
    handleModalSubmit(form) {
      this.confirmLoading = true;
      form.areaCode = this.areaCode;
      
      this.createWebPend(
        form.first_name,
        form.last_name,
        this.store_id,
        form.date,
        form.time,
        form.remark,
        form.covers,
        form.email,
        form.areaCode,
        form.phone
      );
      this.confirmLoading = false;
      this.$refs.myModal.close();
      this.largerBookSuccessModalVisible = true;
    },
    handleBookingEnquiryError(message) {
      this.errorWords = message;
      setTimeout(this.alertTips, 100);
    },

    hideSuccessModal() {
      this.largerBookSuccessModalVisible = false;
      this.clearReservationDraft();
      this.reload();
    },
    resetReservationFlow() {
      this.clearReservationDraft();

      localStorage.removeItem("reservation_id");
      localStorage.removeItem("priceTotal");
      localStorage.removeItem("opayo_set_status");
      localStorage.removeItem("viva_set_status");
      localStorage.removeItem("depositPrice");

      this.step = 0;
      this.currentSize = "";
      this.sizeActive = "";
      this.week = "";
      this.currentDate = "";
      this.currentTime = "";
      this.sessionArr = [];
      this.timeActive = 0;
      this.timeSelectActive = ["", "", ""];
      this.infoForm = {
        firstName: "",
        surname: "",
        areaCode: "+44",
        phone: "",
        email: "",
        remark: "",
        allergy: "",
      };
      this.read = true;
      this.deposite = "";
      this.disabledDay = [];
      this.selectedDate = "";
      this.timeArr = [];
      this.tableString = "";
      this.selectedsessionNum = 0;
      this.nextShow = false;
      this.send_email = 0;
      this.send_sms = 0;
      this.errorWords = "";
      this.depositPrice = "40.00";
      this.duration = 0;
      this.is_holding_time = 0;
      this.allergy_show = 0;
      this.areaCode = "+44";
      this.country = "UK";
      this.reservation_id = 0;
      this.ics_url = "javascript:void(0)";
      this.confirmedModalVisible = false;
      this.largerBookSuccessModalVisible = false;
      this.alertCol = false;
      this.loadingShow = false;
      this.indexShow = false;
      this.reservationShow = true;

      this.$nextTick(() => {
        this.clearDateAndTimeSelection();

        if (
          this.$refs.step3Component &&
          this.$refs.step3Component.$refs &&
          this.$refs.step3Component.$refs.reservationForm &&
          this.$refs.step3Component.$refs.reservationForm.clearValidate
        ) {
          this.$refs.step3Component.$refs.reservationForm.clearValidate();
        }
      });
    },
    makeAnotherBook() {
      this.resetReservationFlow();
    },
    go2AddReservation() {
      this.indexShow = false;
      this.reservationShow = true;
      this.syncReservationStepToRoute(0, { replace: true });
    },
    getMap() {
      // this.locationLat
      // this.locationLng
      this.mapShow = true;
    },
    hideConfirmedModal() {
      this.confirmedModalVisible = false;
    },

    readNot(accepted) {
      this.read = !accepted;
    },
    acceptTheTerm() {
      this.read = false;
    },
    complete() {
      this.loadingShow = true;
      this.createWebReserve(
        this.store_id,
        this.currentDate,
        this.currentTime,
        this.infoForm,
        this.tableString,
        this.currentSize,
        this.selectedsessionNum,
        this.send_email,
        this.send_sms
      );

      //	this.step = 5;
    },
    depositeTabs(val) {
      this.deposite = val;
    },
    modalAllergyConfirm() {
      var allergySelectedStr = "";
      var allergySelectedData = [];
      $("#modalAjax")
        .find('input[name="allergy-checkbox"]:checked')
        .each(function () {
          allergySelectedData.push($(this).val());
          allergySelectedStr += $(this).val() + ", ";
        });
      $("#allergy_data").val(allergySelectedData);
      this.infoForm.allergy = allergySelectedStr;
    },
    allergySelect() {
      if ($("#allergy_data").val() === "") {
        $("#modalAjax")
          .find('input[name="allergy-checkbox"]:checked')
          .each(function () {
            $(this).prop("checked", false);
          });
      }
    },
    termsAndConditions() {
      // $('#acceptBtn').unbind("click").on('click', function () {
      // 	$("#radio-check").prop("checked",true);
      //     $('#confirmSubmit').prop("disabled",false);
      // });
    },
    selectDate(disabledDay) {
      let self = this;
      //		$("#grid-date-col").empty();
      //
      $("#dateSelect-calendar").fullCalendar("destroy");

      $("#dateSelect-calendar").fullCalendar({
        header: {
          left: "title",
          right: "prev,next today",
          center: "",
        },
        buttonIcons: {
          prev: " ti-angle-left",
          next: " ti-angle-right",
        },
        firstDay: 1,
        //	        businessHours: true, // display business hours
        selectable: false,
        selectHelper: false,
        editable: false, // stop drog
        eventLimit: false, // stop move "more" link when too many events
        defaultView: "month",
        fixedWeekCount: false,
        dayHeaderFormat: 'dd',
        dayNamesShort: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
        viewRender: function (view, element, currentView) {
          var minDate = moment().format("YYYY-MM-DD");
          var maxDate = moment().add(1, "year").format("YYYY-MM-DD");
          $(".fc-day-top").each(function () {
            var t = $(this);
            if (t.data("date") > maxDate || t.data("date") < minDate) {
              t.addClass("cannotAdd");
            } else {
              t.addClass("canAdd");
            }
            $.each(disabledDay, function (i, v) {
              if (t.data("date") == v) {
                t.removeClass("canAdd");
                t.addClass("cannotAdd");
              }
            });
          });

          var startDate = moment();
          var endDate = moment().add(1, "year");

          if (startDate >= currentView.start && startDate <= currentView.end) {
            $(".fc-prev-button").prop("disabled", true);
            $(".fc-prev-button").addClass("fc-state-disabled");
          } else {
            $(".fc-prev-button").removeClass("fc-state-disabled");
            $(".fc-prev-button").prop("disabled", false);
          }

          if (endDate >= currentView.start && endDate <= currentView.end) {
            $(".fc-next-button").prop("disabled", true);
            $(".fc-next-button").addClass("fc-state-disabled");
          } else {
            $(".fc-next-button").removeClass("fc-state-disabled");
            $(".fc-next-button").prop("disabled", false);
          }

          $(".fc-row.fc-week.fc-widget-content").each(function () {
            var rowHeight = $(this).height();
            $(this)
              .find(
                ".fc-content-skeleton, .fc-content-skeleton table, .fc-content-skeleton td"
              )
              .height(rowHeight);
            $(this)
              .find(".fc-day-number")
              .css("height", rowHeight - 4);
            var lineHeight = rowHeight - 4;
            $(this)
              .find(".fc-day-number")
              .css("line-height", lineHeight + "px");
          });
          $(".fc-content-skeleton").find("tbody *").empty().remove();
        },
        navLinks: true,
        navLinkDayClick: function (date, jsEvent) {
          var reservationTime = date.format("DD MMM YYYY");
          var reservationDates = date.format("YYYY-MM-DD");
          var reservationWeek = date.format("dddd");
          //		        $('#grid-date-col').html(reservationTime).attr("week",reservationWeek);
          //		        $('#date').val(reservationDates);
          if (
            $(jsEvent.currentTarget).parent(".fc-day-top").hasClass("canAdd")
          ) {
            if (
              date >= moment().add(-1, "days") &&
              date <= moment().add(1, "year")
            ) {
              if (self.selectedDate && self.selectedDate !== reservationDates) {
                self.clearTimeSelection();
              }
              self.currentDate = reservationTime;
              self.week = reservationWeek;
              self.selectedDate = reservationDates;
              self.persistReservationDraft();
              $("#dateSelect-calendar").find("a").removeClass("selected-date");
              $(jsEvent.currentTarget).addClass("selected-date");
              // $('#grid-date-col').html(reservationTime);
              $("#date").val(reservationDates);

            } else {
              self.errorWords =
                "The selected date is unavailable, <br />please choose another date.";
              setTimeout(self.alertTips, 100);

            }
          } else {
            self.errorWords =
              "The selected date is unavailable, <br />please choose another date.";
            setTimeout(self.alertTips, 100);

          }
        },
      });
      $(".fc-today-button").html('<i class="ti-world"></i>');

      $(".fc-row.fc-week.fc-widget-content").each(function () {
        var rowHeight = $(this).height();
        $(this)
          .find(
            ".fc-content-skeleton, .fc-content-skeleton table, .fc-content-skeleton td"
          )
          .height(rowHeight);
        $(this)
          .find(".fc-day-number")
          .css("height", rowHeight - 4);
        var lineHeight = rowHeight - 4;
        $(this)
          .find(".fc-day-number")
          .css("line-height", lineHeight + "px");
      });
      $(".fc-content-skeleton").find("tbody *").empty().remove();

      var defaultDate = $("#date").val();
      if (defaultDate != "") {
        $(".fc-day-top.canAdd").each(function () {
          var calendarDate = $(this).data("date");
          if (calendarDate == defaultDate) {
            $(this).find(".fc-day-number").addClass("selected-date");

          }
        });
      }
    },
    getAreaCode(selectAreaCode, selectCountry) {
      this.areaCode = selectAreaCode;
      this.country = selectCountry;
    },

    back() {
      if (this.step > 0) {
        this.step -= 1;
        return;
      }

      this.$router.back();
    }
  },
  mounted() {
    // this.next();
    // this.getSwiper()
    // this.getCustomStyle();

    // 监听postmessage，为了获取父页面的宽度，然后调整这个项目页面的样式
    // window.addEventListener("message", (event) => {
    //   if (event.origin === "http://localhost:8080") return;
    //   console.log(event);
    //   if (event && event.data) {
    //     // const postData = JSON.parse(event.data);
    //     console.log(event.data);
    //     if (event.data.parentWidth) {
    //       // 监听的是父页面的宽度
    //       this.parentWidth = event.data.parentWidth;
    //     }
    //   }
    // });

    // jQuery validation removed in favor of a-form-model
  },
};
</script>
<style>
#reservation-page-wrapper #all-covers {
  border-color: var(--brandColor);
}

#reservation-page-wrapper .select-col select {
  outline: none;
  -webkit-appearance: none;
  position: relative;
}

#reservation-page-wrapper .select-col::after {
  position: absolute;
  content: "";
  display: block;
  width: 0;
  height: 0;
  right: 10px;
  top: 15px;
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-left: 0.3em solid transparent;
  border-color: #3d1cba transparent transparent transparent;
}

#reservation-page-wrapper #reservation #selectPartySize-mod .radioButtonCol.grid_3 {
  grid-template-columns: repeat(3, 1fr);
}

#reservation-page-wrapper .company-logo {
  width: 100px;
  height: 100px;
}
</style>
<style lang="scss">
#reservation-page-wrapper {
  --reservation-header-height: 60px;
  --reservation-body-overlap: 18px;
  --reservation-footer-spacing: calc(150px + env(safe-area-inset-bottom));
  --reservation-body-top: var(--reservation-header-height);

  &.isFrame {
    --reservation-header-height: 0px;

    #page-index,
    .page-content {
      overflow-y: unset !important;
    }

    &.isWideScreen {

      #page-index,
      .page-content {
        max-width: 65% !important;
      }
    }

    #main-menu,
    #main-nav,
    #main-title {
      width: 100%;
      position: relative !important;
      transform: unset !important;
      max-width: unset !important;
      top: unset !important;
      left: unset !important;
    }

    #reservation {
      .reservation-layout {
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .reservation-body {
        margin-top: 0 !important;
        height: auto !important;
        flex: 1;
        border-radius: 0;
      }

      .reservation-footer {
        position: relative !important;
        left: unset !important;
        bottom: unset !important;
        transform: unset !important;
        padding-top: 20px;
        background: #fff;
      }
    }

    .swiper-container {
      overflow-y: auto !important;
      padding-top: 0 !important;
    }
  }

  #reservation {
    height: 100vh;
    height: 100dvh;

    .reservation-shell,
    .reservation-layout {
      height: 100%;
    }

    .reservation-layout {
      position: relative;
      overflow: hidden;
      background: #fff;
    }

    .reservation-compat-fields {
      display: none;
    }

    .reservation-header {
      position: fixed;
      top: 0;
      z-index: 30;
      height: var(--reservation-header-height);
      width: 100%;
      max-width: 780px;
      min-width: 320px;
      left: 50%;
      transform: translate(-50%, 0);

      &::after {
        display: none;
      }
    }

    .reservation-header-inner {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      padding: 0 20px;
    }

    .reservation-header .store-name {
      position: static;
      width: auto;
      max-width: calc(100% - 72px);
      text-align: center;
    }

    .reservation-header h1 {
      position: static;
      transform: none;
      margin: 0;
      line-height: 1.2;
      font-size: 20px;
      color: #fff !important;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .reservation-back-icon {
      position: absolute;
      left: 20px;
      top: 50%;
      transform: translateY(-50%);
      color: #fff;
      font-size: 20px;
    }

    .reservation-body.swiper-container {
      position: relative;
      top: auto;
      height: calc(100% - var(--reservation-header-height));
      margin-top: var(--reservation-body-top);
      padding: 0 0 var(--reservation-footer-spacing);
      // background: var(--brandColor);
      border-radius: 0;
      z-index: 10;
      overflow-y: auto !important;
      overflow-x: hidden;
    }

    .reservation-body-inner {
      min-height: 100%;
      display: flex;
      flex-direction: column;
    }

    .voucher-container {
      background-color: #FFF3F5;
      color: #FF5D3C;
      text-align: left;
      padding: 12px 40px;
      .voucher-name {
        font-weight: 500;
      }
      .voucher-item-list {
        padding-left: 12px;
        margin-bottom: 0;
      }
      .voucher-item {
        padding-left: 0;
        font-size: 12px;
      }
      .voucher-available {
        font-size: 12px;
      }
    }

    .reservation-content-hero {
      flex-shrink: 0;
      background: var(--brandColor);
      padding: 16px 20px 16px;
    }

    .reservation-step-stack.swiper-wrapper {
      display: block;
      height: auto;
      min-height: 100%;
      flex: 1 0 auto;
      padding-top: 32px;
      padding-bottom: 100px;
      background: #fff;
      border-radius: 28px 28px 0 0;
    }

    .reservation-content-logo {
      text-align: center;

      img {
        display: block;
        width: 84px;
        height: 84px;
        margin: 0 auto;
        object-fit: cover;
        border-radius: 50%;
        background: #fff;
      }
    }

    .step-layout-wrapper {
      display: block;
      width: auto;
      height: auto;
      min-height: 100%;
      padding: 0 20px;
    }

    .reservation-footer {
      position: fixed !important;
      left: 50%;
      bottom: 0;
      transform: translate(-50%, 0);
      width: 100%;
      max-width: 780px;
      min-width: 320px;
      padding: 0 20px calc(30px + env(safe-area-inset-bottom));
      z-index: 40;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0, #fff 28px);

      .reservation-footer-btn {
        width: 100%;
      }
    }
  }

  .tip-grid-col {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #reservation nav.detail-nav {
    border-top: 0;
    border-bottom: 0;
    height: 30px;
  }

  #calendar-modal {
    margin-top: 20px;
  }

  .step-title {
    margin-bottom: 10px;
  }

  .tip-grid-col-bottom {
    height: 27px;
  }

  &.isNarrowTop {
    --reservation-header-height: 74px;
    --reservation-body-top: var(--reservation-header-height);

    #reservation {
      .logo-header {
        height: var(--reservation-header-height);
      }

      .reservation-body.swiper-container {
        height: calc(100% - var(--reservation-header-height));
      }

      .reservation-content-hero {
        padding-top: 12px;
        padding-bottom: 22px;
      }
    }
  }

  .btn {
    border-radius: 6px;
  }

  .new-landing-wrapper {
    background-color: #f5f5f5;
    height: 100vh;
    height: 100dvh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    position: relative;

    .new-swiper-wrap {
      height: 33vh;
      min-height: 250px;
      width: 100%;
      flex-shrink: 0;

      .swiper-container {
        height: 100%;

        .swiper-wrapper {
          height: 100%;
        }
      }

      .landing-banner-image {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
      }

      .swiper-pagination-bullet {
        background: rgba(255, 255, 255, 0.6);
        opacity: 1;
        width: 6px;
        height: 6px;
      }

      .swiper-pagination-bullet-active {
        background: #fff;
      }

      .landing-swiper-pagination {
        bottom: 40px;
      }
    }

    .landing-content-card {
      background-color: #fff;
      border-radius: 20px 20px 0 0;
      position: relative;
      z-index: 10;
      margin-top: -20px;
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;

      .landing-scroll-area {
        flex: 1;
        overflow-y: auto;
        padding: 30px 20px 20px;
      }

      .landing-store-name {
        font-size: 24px;
        font-weight: 700;
        color: #111;
        margin-top: 0;
        margin-bottom: 24px;
      }

      .landing-address-card {
        background-color: #f7f8fa;
        border-radius: 12px;
        padding: 16px;
        display: flex;
        align-items: center;
        cursor: pointer;
        margin-bottom: 30px;

        .landing-address-icon {
          margin-right: 12px;
          display: flex;
          color: #a0a0a0;
          font-size: 20px;
        }

        .landing-address-text {
          flex: 1;
          font-size: 15px;
          color: #111;
          line-height: 1.4;
        }

        .landing-address-nav {
          background-color: var(--brandColor);
          color: #fff;
          border-radius: 50%;
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          margin-left: 10px;

          .nav-arrow {
            transform: rotate(45deg);
            font-size: 16px;
          }
        }
      }

      .landing-restaurant-info {
        h3 {
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 16px;
          color: #111;
        }

        .info-list {
          display: flex;
          flex-direction: column;
          gap: 14px;

          .info-item {
            display: flex;
            align-items: center;
            font-size: 15px;
            color: #111;

            .icon-check {
              color: var(--brandColor);
              margin-right: 12px;
              font-size: 16px;
            }

            .icon-close {
              color: #ccc;
              margin-right: 12px;
              font-size: 16px;
            }
          }
        }
      }

      .landing-notes-info {
        margin-top: 24px;

        h3 {
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 12px;
          color: #111;
        }

        .notes-text {
          font-size: 15px;
          color: #333;
          line-height: 1.5;
          background: #f7f8fa;
          padding: 12px;
          border-radius: 8px;
        }
      }

      .landing-reserve-btn-wrap {
        padding: 10px 20px 30px;
        padding-bottom: calc(30px + env(safe-area-inset-bottom));
        background-color: #fff;
        border-top: 1px solid #f0f0f0;
      }
    }
  }

  // Planning tip fixed at bottom
  .planning-tip-wrapper {
    margin-bottom: 20px;

    .party-size-tip {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 16px;
      background-color: #fdf6db;
      border-radius: 12px;
      cursor: pointer;
      transition: background-color 0.2s;

      &:hover {
        background-color: #fce9a8;
      }

      .tip-icon {
        width: 20px;
        height: 20px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .tip-text {
        flex: 1;
        font-size: 13px;
        color: #7B7D7F;
        // line-height: 1;
        text-align: left;
      }
    }
  }
}

.base-modal-wrap.reservation-feedback-modal {
  .ant-modal {
    width: calc(100vw - 32px) !important;
    max-width: 440px;
  }

  .ant-modal-content {
    border-radius: 24px;
    overflow: hidden;
    box-shadow: 0 24px 48px rgba(17, 24, 39, 0.16);
  }

  .ant-modal-header {
    display: none;
  }

  .ant-modal-body {
    padding: 28px 24px 18px;
  }

  .base-modal-footer {
    margin-top: 18px;
  }

  .base-modal-footer .btn-submit {
    width: 100%;
    min-height: 54px;
    border-radius: 14px;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.02em;
  }
}

.reservation-modal-card {
  text-align: left;
}

.reservation-modal-hero {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 18px;
  border-radius: 20px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98), var(--brandColor10));
  border: 1px solid rgba(17, 24, 39, 0.05);
}

.reservation-modal-hero--success {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(16, 185, 129, 0.12));
}

.reservation-modal-badge {
  width: 56px;
  height: 56px;
  border-radius: 18px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 12px 24px rgba(17, 24, 39, 0.08);
  flex-shrink: 0;

  img {
    width: 30px;
    height: 30px;
    object-fit: contain;
  }
}

.reservation-modal-badge--success {
  background: linear-gradient(135deg, #22c55e, #16a34a);
  color: #fff;
  font-size: 26px;
}

.reservation-modal-copy {
  min-width: 0;

  h3 {
    margin: 2px 0 8px;
    font-size: 24px;
    line-height: 1.15;
    font-weight: 700;
    color: #101828;
  }
}

.reservation-modal-lead {
  margin: 0;
  font-size: 14px;
  line-height: 1.65;
  color: #4b5563;
}

.reservation-modal-note {
  margin-top: 14px;
  padding: 16px 18px;
  border-radius: 18px;
  background: #f8fafc;
  border: 1px solid #e8eef5;

  p {
    margin: 0;
    font-size: 13px;
    line-height: 1.7;
    color: #5b6472;
  }
}

.reservation-modal-note--soft {
  background: rgba(16, 185, 129, 0.06);
  border-color: rgba(16, 185, 129, 0.14);
}

.reservation-modal-note-label {
  display: inline-flex;
  align-items: center;
  margin-bottom: 8px;
  padding: 5px 10px;
  border-radius: 999px;
  background: var(--brandColor10);
  color: var(--brandColor);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.reservation-modal-accent {
  color: var(--brandColor);
  font-weight: 700;
}

@media screen and (max-width: 480px) {
  .base-modal-wrap.reservation-feedback-modal {
    .ant-modal-body {
      padding: 22px 18px 16px;
    }
  }

  .reservation-modal-hero {
    gap: 14px;
    padding: 16px;
  }

  .reservation-modal-badge {
    width: 50px;
    height: 50px;
    border-radius: 16px;

    img {
      width: 26px;
      height: 26px;
    }
  }

  .reservation-modal-badge--success {
    font-size: 22px;
  }

  .reservation-modal-copy h3 {
    font-size: 21px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/Reservation.vue